define("shared/utils/number-helpers/compute-sign", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class computeSign
   * @extends Utils
   */

  /**
   * Computes the sign of a numerical value.
   *
   * @method computeSign
   * @param {Number} value Numerical value
   *
   * @return {String} Sign of value
   */
  const computeSign = value => {
    if (value > 0) {
      return '+';
    } else if (value < 0) {
      return '-';
    }
    return '';
  };
  var _default = _exports.default = computeSign;
});